import { MutationTree } from 'vuex'
import { IPaymentState } from '@/store/payment/state'
import { Types, Fetch, Error } from '@/store/payment/types'

const mutations: MutationTree<IPaymentState> = {
  [Types.fetch](state, action: Fetch) {
    state.cards = action.payload
    state.error = null
  },
  [Types.error](state, action: Error) {
    state.error = action.payload
  }
}

export default mutations
